import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import cn from 'classnames'
import { EventType } from '../types.js'
import { Session } from './ScheduleSession.js'

export const Day = ({ dayWidth, rowHeight, day, events }) => {
  const sessions = useMemo(
    () => events.flatMap(event => event.sessions).filter(session => session.datetime.includes(day)),
    [events, day]
  )
  const sessionEventIds = useMemo(() => sessions.map(session => session.event_id), [sessions])
  const dummySessions = useMemo(
    () => events.map((event, index) => [event.id, index]).filter(([eventId]) => !sessionEventIds.includes(eventId)),
    [events, sessionEventIds]
  )
  return (
    <div className="schedule-day-inner">
      {dummySessions.map(([eventId, index]) => (
        <div
          key={`blank-${eventId}`}
          className={cn('schedule-event-blank cursor-grab', index === events.length - 1 && 'is-last')}
          style={{ top: index * rowHeight, height: rowHeight, width: dayWidth }}
        />
      ))}
      {sessions.map(session => {
        const event = events.find(event => event.id == session.event_id)
        const index = events.indexOf(event)
        return (
          <Session
            key={session.id}
            session={session}
            event={event}
            className={index === events.length - 1 && 'is-last'}
            style={{ top: index * rowHeight, height: rowHeight, width: dayWidth }}
          />
        )
      })}
    </div>
  )
}

Day.propTypes = {
  dayWidth: PropTypes.number.isRequired,
  rowHeight: PropTypes.number.isRequired,
  day: PropTypes.string.isRequired,
  events: PropTypes.arrayOf(EventType).isRequired,
}
